import { mapper } from "src/app/tools/mapping/mapper"
import { EMilieuPrelevementAir } from "./enum/milieu-prelevement"
import { PrelevementAirDTO } from "src/app/services/dto/prelevement-air.dto"
import { EMethodePrelevement } from "./enum/methode-prelevement"
import { Prelevement } from "../prelevement"
import { AutoMap } from "@automapper/classes"
import { ELieuPrelevementAir } from "./enum/lieu-prelevement"
import { BaseDOM } from "../base.dom"
import { Appareil } from "../Qualif/appareil"

export class PrelevementAir extends BaseDOM<PrelevementAir> {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    TempsSedimentation?: number
    @AutoMap()
    VolumeAirPreleve?: number
    @AutoMap()
    Observations: string = ''
    @AutoMap()
    MilieuPrelevement: EMilieuPrelevementAir = EMilieuPrelevementAir.PCA_SAB
    @AutoMap()
    LieuPrelevement: ELieuPrelevementAir = ELieuPrelevementAir.Autre
    @AutoMap()
    AutreLieuPrelevement: string = ''
    @AutoMap()
    MethodePrelevementAir: EMethodePrelevement = EMethodePrelevement.Impaction;
    @AutoMap()
    Prelevement: Prelevement = new Prelevement();

}